import { render, staticRenderFns } from "./AuthorizationCode.vue?vue&type=template&id=f969309a&scoped=true&"
import script from "./AuthorizationCode.vue?vue&type=script&lang=js&"
export * from "./AuthorizationCode.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationCode.vue?vue&type=style&index=0&id=f969309a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f969309a",
  null
  
)

export default component.exports